<template>
  <v-dialog v-model="viewDialog" scrollable persistent max-width="700">
    <v-card>
      <v-card-title>patient details</v-card-title>
      <v-card-text>
        <!--        {{ myData }}-->
        <div class="twentyTwentyFiveList">
          <div class="twentyTwentyFiveList_item">
            <div class="label">my picture</div>
            <div class="text">
              <!--              {{ myData.user.my_pix }}-->
              <v-avatar>
                <v-img :src="myData.user.my_pix" max-height="50" />
              </v-avatar>
            </div>
          </div>

          <div class="twentyTwentyFiveList_item">
            <div class="label">full name</div>
            <div class="text capitalize">
              {{ myData.user.salutations }} {{ myData.user.first_name }}
              {{ myData.user.mid_name }}
              {{ myData.user.last_name }}
            </div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">date of birth</div>
            <div class="text">{{ myData.user.date_of_birth }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">mobile phone</div>
            <div class="text">{{ myData.user.mobile_phone }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">email</div>
            <div class="text">{{ myData.user.email }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">active</div>
            <div class="text">{{ myData.user.active }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">account reset</div>
            <div class="text">{{ myData.user.my_reset }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">updated</div>
            <div class="text">{{ myData.user.updated | myDating }}</div>
          </div>
          <div class="twentyTwentyFiveList_item">
            <div class="label">created</div>
            <div class="text">{{ myData.created | myDating }}</div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              close
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//   import Restful from "@/services/RestFul";
//   import moment from "moment";
//   import Utils from "./../../../../mixins/utils";
export default {
  props: {
    viewDialog: Boolean,
    myId: { type: Number, default: 0 },
    myData: { type: Object, default: null },
  },
  // mixins: [Utils],
  data() {
    return {
      responseMessage: null,
    };
  },
  created() {},
  methods: {
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closeDetail", payload);
    },
  },
};
</script>
